import basicController from "servicestack/basic.controller.properties";

export default class VendorDashboardHeaderController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
  }
}
